import React from 'react'
import {Link} from 'react-router-dom'
import BannerSliderTwo from './BannerSliderTwo'
import TestimonialSlider from './TestimonialSlider'

function HomeTwo() {
    const renderCalendar = () => {
        return (
          <table className="calendar">
            <thead className='calendar-heading'>
              <tr>
                <th></th>
                <th>Sun</th>
                <th>Mon</th>
                <th>Tue</th>
                <th>Wed</th>
                <th>Thu</th>
                <th>Fri</th>
                <th>Sat</th>
              </tr>
            </thead>
            <tbody>
            <tr>
                <td>12am</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>1am</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>2am</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>3am</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>4am</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>5am</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>6am</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>7am</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>8am</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>9am</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>10am</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>11am</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>12pm</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>1pm</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>2pm</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>3pm</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>4pm</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>5pm</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>6pm</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>7pm</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>8pm</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>9pm</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>10pm</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>11pm</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        );
      };
  return (
    <div>
    <BannerSliderTwo/>
    {/* <!-- Banner End -->
    <!-- About Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="row align-items-center justify-content-between">
                <div className="col-lg-6">
                    <div className="about_image mb-xl-30">
                        <img src="/tm/react/fit2fine/assets/images/about.jpg" alt="img" className="image-fit"/>
                    </div>
                </div>
                <div className="col-lg-5">
                    <div className="section-header text-start">
                        <h3 className="title">Who We <span> Are</span></h3>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                    </div>
                    <Link to="/about" className="thm-btn mb-xl-30">Read More</Link>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- About End -->
    <!-- Programs Start --> */}
    <section className="section-padding section-bg-fix" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/bg/bg_1.png)' }}>
        <div className="container">
            <div className="section-header">
                <h3 className="title">Our <span> Programs</span></h3>
                <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore </p>
            </div>
            <div className="row">
                <div className="col-lg-3 col-sm-6">
                    <div className="program_box section-bg" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/program/1.jpg)' }}>
                        <div className="transform-center">
                            <div className="program_text">
                                <h5 className="title mb-3">
                                    <Link to="/program">Chest Workout</Link>
                                </h5>
                                <Link to="/program" className="thm-btn btn-small">More</Link>
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-sm-6">
                    <div className="program_box section-bg" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/program/2.jpg)' }}>
                        <div className="transform-center">
                            <div className="program_text">
                                <h5 className="title mb-3">
                                    <Link to="/program">Cardio Training</Link>
                                </h5>
                                <Link to="/program" className="thm-btn btn-small">More</Link>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-3 col-sm-6">
                    <div className="program_box section-bg" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/program/3.jpg)' }}>
                        <div className="transform-center">
                            <div className="program_text">
                                <h5 className="title mb-3">
                                    <Link to="/program">Legpress or Squat</Link>
                                </h5>
                                <Link to="/program" className="thm-btn btn-small">More</Link>
                            </div>
                        </div>
                    </div>
                </div>
              
                <div className="col-lg-3 col-sm-6">
                    <div className="program_box section-bg" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/program/4.jpg)' }}>
                        <div className="transform-center">
                            <div className="program_text">
                                <h5 className="title mb-3">
                                    <Link to="/program">Our Instructor</Link>
                                </h5>
                                <Link to="/program" className="thm-btn btn-small">More</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Programs End -->
    <!-- Trainer Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="section-header">
                <h3 className="title">Our <span> Trainer</span></h3>
                <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore </p>
            </div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="trainer_box">
                        <div className="trainer_image">
                            <Link to="/trainer" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/trainer/1.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="trainer_text">
                            <h4 className="title mb-0 lh-1">
                                <Link to="/trainer">Lily Michelle</Link>
                            </h4>
                            <p className="desi mb-2 thm-color-one">Trainer</p>
                            <p className="text mb-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore</p>
                            <ul className="social_icons">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-6">
                    <div className="trainer_box">
                        <div className="trainer_image">
                            <Link to="/trainer" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/trainer/2.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="trainer_text">
                            <h4 className="title mb-0 lh-1">
                                <Link to="/trainer">Rawfit Adonis</Link>
                            </h4>
                            <p className="desi mb-2 thm-color-one">Trainer</p>
                            <p className="text mb-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore</p>
                            <ul className="social_icons">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-6">
                    <div className="trainer_box">
                        <div className="trainer_image">
                            <Link to="/trainer" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/trainer/3.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="trainer_text">
                            <h4 className="title mb-0 lh-1">
                                <Link to="/trainer">Slimscape</Link>
                            </h4>
                            <p className="desi mb-2 thm-color-one">Trainer</p>
                            <p className="text mb-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore</p>
                            <ul className="social_icons">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-6">
                    <div className="trainer_box">
                        <div className="trainer_image">
                            <Link to="/trainer" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/trainer/4.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="trainer_text">
                            <h4 className="title mb-0 lh-1">
                                <Link to="/trainer">Trim Ranger</Link>
                            </h4>
                            <p className="desi mb-2 thm-color-one">Trainer</p>
                            <p className="text mb-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore</p>
                            <ul className="social_icons">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Trainer End -->
    <!-- Gallery Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="section-header">
                <h3 className="title">Our <span> Gallery</span></h3>
                <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore </p>
            </div>
            <div className="row">
                <div className="col-lg-3 col-sm-6">
                    <div className="gallery_box">
                        <img src="/tm/react/fit2fine/assets/images/gallery/1.jpg" alt="img" className="image-fit"/>
                        <Link to="/tm/react/fit2fine/assets/images/gallery/1.jpg" className="gallery_icon popup-image">
                            <i className="fal fa-search"></i>
                        </Link>
                    </div>
                </div>
                
                <div className="col-lg-3 col-sm-6">
                    <div className="gallery_box">
                        <img src="/tm/react/fit2fine/assets/images/gallery/2.jpg" alt="img" className="image-fit"/>
                        <Link to="/tm/react/fit2fine/assets/images/gallery/2.jpg" className="gallery_icon popup-image">
                            <i className="fal fa-search"></i>
                        </Link>
                    </div>
                </div>
                
                <div className="col-lg-3 col-sm-6">
                    <div className="gallery_box">
                        <img src="/tm/react/fit2fine/assets/images/gallery/3.jpg" alt="img" className="image-fit"/>
                        <Link to="/tm/react/fit2fine/assets/images/gallery/3.jpg" className="gallery_icon popup-image">
                            <i className="fal fa-search"></i>
                        </Link>
                    </div>
                </div>
              
                <div className="col-lg-3 col-sm-6">
                    <div className="gallery_box">
                        <img src="/tm/react/fit2fine/assets/images/gallery/4.jpg" alt="img" className="image-fit"/>
                        <Link to="/tm/react/fit2fine/assets/images/gallery/4.jpg" className="gallery_icon popup-image">
                            <i className="fal fa-search"></i>
                        </Link>
                    </div>
                </div>
               
                <div className="col-lg-3 col-sm-6">
                    <div className="gallery_box">
                        <img src="/tm/react/fit2fine/assets/images/gallery/5.jpg" alt="img" className="image-fit"/>
                        <Link to="/tm/react/fit2fine/assets/images/gallery/5.jpg" className="gallery_icon popup-image">
                            <i className="fal fa-search"></i>
                        </Link>
                    </div>
                </div>
                
                <div className="col-lg-3 col-sm-6">
                    <div className="gallery_box">
                        <img src="/tm/react/fit2fine/assets/images/gallery/6.jpg" alt="img" className="image-fit"/>
                        <Link to="/tm/react/fit2fine/assets/images/gallery/6.jpg" className="gallery_icon popup-image">
                            <i className="fal fa-search"></i>
                        </Link>
                    </div>
                </div>
                
                <div className="col-lg-3 col-sm-6">
                    <div className="gallery_box">
                        <img src="/tm/react/fit2fine/assets/images/gallery/7.jpg" alt="img" className="image-fit"/>
                        <Link to="/tm/react/fit2fine/assets/images/gallery/7.jpg" className="gallery_icon popup-image">
                            <i className="fal fa-search"></i>
                        </Link>
                    </div>
                </div>
               
                <div className="col-lg-3 col-sm-6">
                    <div className="gallery_box">
                        <img src="/tm/react/fit2fine/assets/images/gallery/8.jpg" alt="img" className="image-fit"/>
                        <Link to="/tm/react/fit2fine/assets/images/gallery/8.jpg" className="gallery_icon popup-image">
                            <i className="fal fa-search"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Gallery End -->
    <!-- Team Start --> */}
    <section className="section-padding pt-0">
        <div className="container">
            <div className="section-header">
                <h3 className="title">Our <span> Team</span></h3>
                <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore </p>
            </div>
            <div className="row">
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/1.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Frsixa Deam</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/2.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Alexa Nairo</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/3.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Merica Haric</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
               
                <div className="col-lg-3 col-sm-6">
                    <div className="team_block">
                        <div className="team_image">
                            <Link to="#" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/team/4.jpg" alt="img" className="image-fit"/>
                            </Link>
                            <Link to="#" className="transform-center thm-btn btn-small">View Now</Link>
                        </div>
                        <div className="team_caption">
                            <p className="desig">Trainer</p>
                            <h5 className="name"><Link to="#">Steve Cross</Link></h5>
                            <ul className="team_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Team End -->
    <!-- Testimonials Start --> */}
    <TestimonialSlider/>
    {/* <!-- Testimonials End -->
    <!-- Blog Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="section-header">
                <h3 className="title">Latest <span> News</span></h3>
                <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore </p>
            </div>
            <div className="row justify-content-center">
                <article className="col-lg-4 col-md-6">
                    <div className="post post_grid">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/blog/1.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <ul className="post_meta">
                                <li>
                                    <Link to="/blog-details">
                                        <i className="bi-calendar3"></i>
                                        20 Jan 2024
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-grid">
                                        <i className="bi-person"></i>
                                        by Admin
                                    </Link>
                                </li>
                            </ul>
                            <h2 className="post_title">
                                <Link to="/blog-details">You Will Become As Off Small Your Desire. </Link>
                            </h2>
                            <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        </div>
                        <div className="post_footer">
                            <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                        </div>
                    </div>
                </article>
               
                <article className="col-lg-4 col-md-6">
                    <div className="post post_grid">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/blog/2.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <ul className="post_meta">
                                <li>
                                    <Link to="/blog-details">
                                        <i className="bi-calendar3"></i>
                                        18 Fab 2024
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-grid">
                                        <i className="bi-person"></i>
                                        by Admin
                                    </Link>
                                </li>
                            </ul>
                            <h2 className="post_title">
                                <Link to="/blog-details">10 Tips How to Prepare Meals Fast and Easy. </Link>
                            </h2>
                            <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        </div>
                        <div className="post_footer">
                            <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                        </div>
                    </div>
                </article>
                
                <article className="col-lg-4 col-md-6">
                    <div className="post post_grid">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/blog/3.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <ul className="post_meta">
                                <li>
                                    <Link to="/blog-details">
                                        <i className="bi-calendar3"></i>
                                        12 March 2024
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-grid">
                                        <i className="bi-person"></i>
                                        by Admin
                                    </Link>
                                </li>
                            </ul>
                            <h2 className="post_title">
                                <Link to="/blog-details">How to Maximise Time Spent at the Gym. </Link>
                            </h2>
                            <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        </div>
                        <div className="post_footer">
                            <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </section>
    {/* <!-- Blog End -->
    <!-- Schedule Start --> */}
    <section className="section pt-0">
        <div className="container">
            <div className="section-header">
                <h3 className="title">Training <span> Schedule</span></h3>
                <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore </p>
            </div>
            <div className='text-center schedule_calendar' >
                <h5 className='pt-2'>MAR 10 – 16, 2024</h5>
            </div>
            <div className="row jhhtrbdyus">
                <div className="col-12">
                    {renderCalendar()}
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default HomeTwo